module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (42).35d76193.jpg";